import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';

import {environment} from '../../../environments/environment';


import {AppointmentDataModel} from './models/appoitment-model';

import {LocationModel, OperatoryModel} from './models/operatory-model';
// import 'rxjs/add/operator/catch';
import { throwError } from 'rxjs';
import {AppoitmentDetaileModel} from './models/appoitment-detaile-model';
import {UserService} from '../../services/user.service';
import {WaitListViewModel} from "../../models/appointments/dataAppointmentWaitList.model";



@Injectable({
    providedIn: 'root'
})
export class SchedulerService {

    constructor(private http: HttpClient) {
    }

    getAppointments(tdocid: string, dateRangeFrom: string, dateRangeTo: string ): Observable<AppointmentDataModel[]> {
        let url: string;
        const method: string = 'scheduler/get-appointments-for-practice/' + tdocid + '/' + dateRangeFrom + '/' + dateRangeTo;

        url = environment.TDOurl + method;

        return this.http.get<AppointmentDataModel[]>(url);
        // .pipe(
        //   this.catchError(this.handleError)
        // );
    }

    // the data parameter for the dialog
    getAllPatientAppointments(tdocid: string, patientId: string): Observable<AppointmentDataModel[]> {
        let url: string;
        const method: string = 'scheduler/get-appointments-for-patient/' + tdocid + '/' + patientId;

        url = environment.TDOurl + method;

        return this.http.get<AppointmentDataModel[]>(url);
    }

    getAllPatientCases( patientId: string): Observable<any> {
        let url: string;
        const method: string = 'scheduler/get-patient-cases/'  + patientId;

        url = environment.TDOurl + method;

        return this.http.get<string>(url);
    }


    getAppoitmnetDetailes(appointmentId: string): Observable<AppoitmentDetaileModel[]> {
        let url: string;
        const method: string = 'scheduler/get-appointment-details/' + appointmentId;

        url = environment.TDOurl + method;

        return this.http.get<AppoitmentDetaileModel[]>(url);



    }



    getBusinessHours(tdocid: string, locids: number[]): Observable<LocationModel[]> {

        let url: string;
        const method: string = 'scheduler/get-business-hours/' + tdocid  ;

        //url = environment.TDOurl + method + '/?locids=' + locids.join('-');
        url = environment.TDOurl + method + '/' + locids.join('-');

        //console.log('getBusinessHours', url);

        return this.http.get<any>(url);

    }


    getLocations(tdocid: string): Observable<LocationModel[]> {

        let url: string;
        const method: string = 'scheduler/get-locations-for-pratcice/' + tdocid  ;

        url = environment.TDOurl + method;

        return this.http.get<LocationModel[]>(url);

    }





    getOperatories(tdocid: string ): Observable<OperatoryModel[]> {
        let url: string;
        const method: string = 'scheduler/get-operatories-for-pratcice/' + tdocid  ;

        url = environment.TDOurl + method;

        return this.http.get<OperatoryModel[]>(url);
    }


    private handleError(error: HttpErrorResponse) {
        if (error.status === 0) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(
                `Backend returned code ${error.status}, body was: `, error.error);
        }
        // Return an observable with a user-facing error message.
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }

    private catchError(handleError: (error: HttpErrorResponse) => any) {
        return undefined;
    }

    getProcedureGroup(procedureGroupID: string): Observable<any[]> {
        return this.http.get<any[]>(`/api/procedureGroup/${procedureGroupID}`, UserService.authorizationHeaderObject);
    }

    saveNewAppoitment(appointment: AppointmentDataModel): Observable<AppointmentDataModel>   {

        appointment.ApptFlags = '';
        appointment.PatientFlags = '';

        return this.http.post<AppointmentDataModel>('/api/scheduler/save-new-appointment', appointment,  UserService.authorizationHeaderObject);
    }
    updateAppoitment(appointment: AppointmentDataModel): Observable<AppointmentDataModel>   {

        appointment.ApptFlags = '';
        appointment.PatientFlags = '';

        return this.http.post<AppointmentDataModel>('/api/scheduler/update-appointment', appointment,  UserService.authorizationHeaderObject);
    }


    deleteAppointment(AppointmentID: string): Observable<string>   {

        // calendar spot reserved and here we manulay delete that app slot
        return this.http.get<string>(`/api/scheduler/delete-appointment/${AppointmentID}`,  UserService.authorizationHeaderObject);
    }

    removeAppointmentReservation(appointmentid: string): Observable<string>   {

        // calendar spot reserved isReservarion and here we manulay delete that app slot

        return this.http.get<string>(`/api/scheduler/remove-appointment-reservation/${appointmentid}`,  UserService.authorizationHeaderObject);
    }


    getAppointmentWaitList(){
      return this.http.get<WaitListViewModel[]>('api/scheduler/get-appointment-wait-list');
    }

    rescheduleAppoitment(theApoitment: any   ) {

      return this.http.post<any>('/api/scheduler/reschedule-appointment', theApoitment,  UserService.authorizationHeaderObject);
    }

    removeAppoitmentFromWaitList(appoitmentID: string) {
      return this.http.get<any>(`api/scheduler/remove-appointment-wait-list/${appoitmentID}`, UserService.authorizationHeaderObject);

    }

}
